@if (data) {
  <app-title headerType="3" [title]="data?.title"></app-title>
  <form [formGroup]="formGroup">
    <app-dynamic-text-area [field]="getFieldByKey('observaciones')">
    </app-dynamic-text-area>
  </form>
}
